import { render, staticRenderFns } from "./ListaAtendOutros.vue?vue&type=template&id=af6095fe&"
import script from "./ListaAtendOutros.vue?vue&type=script&lang=js&"
export * from "./ListaAtendOutros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports